import React, { PropTypes } from 'react';
import Content from 'components/Content';
import Column from 'components/Content/Column';
import Page from 'components/Page';
import WaveLink from 'components/WaveLink';
import Pattern from 'components/Pattern';
import PureComponent from 'components/PureComponent';
import Socials from 'components/Socials';
import Next from 'components/Next';
import Bottle from 'components/Bottle';
import DocumentTitle from 'react-document-title';
import checkMobile from 'utils/checkMobile';
// import CodeButton from 'components/CodeButton';
import BuyButton from 'components/BuyButton';

import certs from './certs.png';

class Consist extends PureComponent {
  static contextTypes = {
    deviceType: PropTypes.string
  };

  render() {
    require('./Consist.styl');

    const { deviceType } = this.context;
    const isMobile = checkMobile(deviceType, this.props.viewport);
    const pageProps = {
      style: {
        backgroundImage: isMobile ? '' : `url(${this.props.backgroundImage[0]})`
      }
    };

    return (
      <Page {...pageProps}>
        <DocumentTitle title="Уникальность — Глубинная байкальская вода BAIKAL430" />

        {!isMobile && [
          <Pattern
            key="1"
            left="43%"
            colorLeft={'#21B0FF'}
            colorRight={'transparent'}
          />,
          <Pattern key="2" left="43%" />
        ]}

        <Content>
          <Column style={{ paddingBottom: 40 }}>
            <h2>Уникальность глубинной воды</h2>
            <p>
              Растворённый в Байкале кислород придаёт воде свежесть вкуса, а
              сверхлёгкая минерализация — несравненное преимущество перед любой
              другой водой. Цивилизация и человек не оказали никакого
              воздействия на байкальскую экосистему, и чистота воды великого
              озера доходит до нас в&nbsp;первозданном&nbsp;виде.
            </p>

            {/* {!isMobile && (
              <CodeButton
                style={{
                  marginTop: 40
                }}
              />
            )} */}

            {/* {!isMobile && (
              <BuyButton
                style={{
                  marginTop: 20
                }}
              />
            )} */}
          </Column>

          {isMobile && (
            <Column
              className="Content__column--bottle"
              style={{
                backgroundImage: `url(${this.props.backgroundImage[0]})`
              }}
            >
              <Bottle cover={this.props.backgroundImage[1]} />
            </Column>
          )}

          <Column>
            {/* {isMobile && (
              <CodeButton
                style={{
                  marginBottom: 20
                }}
              />
            )} */}

            {/* {isMobile && (
              <BuyButton
                style={{
                  marginBottom: 40
                }}
              />
            )} */}

            <h2>Контроль качества</h2>
            <p>
              Международная сертификация производства и постоянный контроль
              качества всех этапов производства BAIKALSEA Company
            </p>
            <p>
              <img
                src={certs}
                alt="ISO-22000 и FSSC-22000"
                width="273"
                height="32"
              />
            </p>
            <p>
      
              <WaveLink
                color="#FFF"
                className="Consist__download"
                href="/files/quality.pdf"
                download="Отчет о качестве воды.pdf"
                style={{
                  paddingBottom: 5
                }}
              >
                <span
                  style={{
                    textTransform: 'uppercase',
                    fontSize: 17,
                    fontFamily:
                      "'Promixa Nova Condensed', Helvertica, Arial, sans-serif"
                  }}
                >
                  Отчёт о качестве воды
                </span>
              </WaveLink>
              <br/><br/>
              <WaveLink
                color="#FFF"
                className="Consist__download"
                href="/files/cz_marking_03_2025.pdf"
                download="Важные изменения в маркировке упакованной воды.pdf"
                style={{
                  paddingBottom: 5
                }}
              >
                <span
                  style={{
                    textTransform: 'uppercase',
                    fontSize: 17,
                    fontFamily:
                      "'Promixa Nova Condensed', Helvertica, Arial, sans-serif"
                  }}
                >
                 Важные изменения в маркировке упакованной воды
                </span>
              </WaveLink>
   
            </p>
          </Column>
        </Content>

        <div className="Page__socials">
          <Socials light />
        </div>

        {isMobile && <Next to="/source" label="Место добычи" />}
      </Page>
    );
  }
}

export default Consist;



// WEBPACK FOOTER //
// ./src/pages/Consist/Consist.js